import { Navigate, useLocation } from "react-router";

export default function Winner() {
  const { state } = useLocation();

  if (!state?.redirected) {
    return <Navigate to="/" />;
  }

  return (
    <div className="card mx-auto w-full max-w-lg px-4 py-8 text-center">
      <h1 className="text-red mb-4 font-bold">{"Thank you for entering! "}</h1>
      <h2 className="text-red mx-auto mb-6 max-w-xs text-center font-bold">
        We will verify your receipt and notify you if you have won one of our
        daily prizes tomorrow using the email provided. 
      </h2>

      {/* <img
        id={state?.prize?.id}
        className="w-full mb-4"
        src={state?.prize?.image}
        alt="Costa Gifts"
      /> */}

      {/* <h1 className="mb-4 font-bold text-red">{state?.prize?.title}</h1> */}

      <p className="text-red mx-auto max-w-xs text-center mb-2">
        You’ve also been entered into the prize draw to win a top tier prize - a
        holiday to Barcelona OR £2k cash prize.
      </p>

      <p className="text-red mx-auto max-w-xs text-center mb-4">Good Luck! </p>

      <p className="text-red mx-auto max-w-xs text-center mb-2 text-[12px]">
        The top tier draw will be conducted at the end of the promotional period
        and the winners will both be notified within 7 days of closing with
        details on how to redeem their prize. 
      </p>

      <p className="text-red mx-auto max-w-xs text-center mb-2 text-[12px]">
        If you have not won a daily prize or prize draw prize, you won’t hear
        from us.  
      </p>
      <p className="text-red mx-auto max-w-xs text-center text-[12px]">
        Please do get in touch with us using the email address in our{" "}
        <a href="/terms" target="_blank" className="underline">
          T&Cs
        </a>{" "}
        if you want to know anything else. {" "}
      </p>
    </div>
  );
}
